import { Box, InputAdornment, MenuItem, OutlinedInput, Stack, SvgIcon, TextField } from "@mui/material";
import { ChangeEvent, FC, FormEvent, MutableRefObject, useCallback } from "react"
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../../locales/tokens";

interface IProps {
    sortBy: string;
    searchTextRef: MutableRefObject<HTMLInputElement | null>;
    handleSortBy: (sortBy: string) => void;
    handleChangeSearch: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, sortBy: string) => void;
    handleSearchTextChange: (event: FormEvent<HTMLFormElement>) => void;
};

export const UserSearch: FC<IProps> = ({ searchTextRef, handleChangeSearch, handleSearchTextChange, handleSortBy, sortBy }) => {
    const { t } = useTranslation();

    const sortOptions = [
        { label: t(tokens.users.all), value: 'All' },
        { label: t(tokens.users.interns), value: 'Intern' }
    ];

    const onSortChange = useCallback((event: ChangeEvent<HTMLInputElement>): void => {
        const sortDir = event.target.value as string;
        handleSortBy(sortDir);
    }, [handleSortBy]);

    return (
        <Stack direction='row' spacing={1} alignItems='center' mt={3}>
            <Box component="form" onSubmit={handleSearchTextChange} flex={3} >
                <OutlinedInput
                    defaultValue=""
                    fullWidth
                    inputProps={{ ref: searchTextRef }}
                    onChange={(e)=>handleChangeSearch(e, sortBy)}
                    placeholder={t(tokens.users.serachUser)}
                    startAdornment={(
                        <InputAdornment position="start">
                            <SvgIcon>
                                <SearchIcon />
                            </SvgIcon>
                        </InputAdornment>
                    )}
                    size="small"
                />
            </Box>
            <TextField
                id="outlined-basic"
                label={t(tokens.users.users)}
                select variant="outlined"
                value={sortBy}
                onChange={onSortChange}
                sx={{ width: '150px', flex: 1 }}
                size="small"
            >
                {sortOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        </Stack>

    )
};